// inspired by https://stackoverflow.com/a/60660046/5895550
import { useEffect, useCallback } from 'react';

function useIdleMonitor ({ timeout, onTimeout }) {
    const callOnTimeout = useCallback(() => {
        onTimeout && onTimeout();
    }, [onTimeout]);

    useEffect(() => {
        let timer;

        const startTimer = () => {
            if (timer) clearTimeout(timer);
            timer = setTimeout(callOnTimeout, timeout);
        };

        const events = [
            'load',
            'mousemove',
            'mousedown',
            'click',
            'scroll',
            'keypress'
        ];

        for (const i in events) {
            window.addEventListener(events[i], startTimer);
        }

        startTimer();
        return () => {
            for (const i in events) {
                window.removeEventListener(events[i], startTimer);
                if (timer) clearTimeout(timer);
            }
        };
    }, [callOnTimeout, timeout]);
}

export default useIdleMonitor;
